import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
interface AnimatedNumberProps {
  value: number;
  className?: string;
}
export function AnimatedNumber({
  value,
  className = ''
}: AnimatedNumberProps) {
  const [displayValue, setDisplayValue] = useState(value);
  const spring = useSpring(value, {
    stiffness: 100,
    damping: 30
  });
  useEffect(() => {
    spring.set(value);
  }, [spring, value]);
  useEffect(() => {
    const unsubscribe = spring.on('change', latest => {
      setDisplayValue(Math.round(latest));
    });
    return unsubscribe;
  }, [spring]);
  return <span className={className} data-id="element-38" data-mp="388twrxjti5ok">{displayValue}</span>;
}